import { render, staticRenderFns } from "./PrintAnnualResultBulkIPriPrim.vue?vue&type=template&id=7613581e&scoped=true&style=background-color%3A%20white%3B&"
import script from "./PrintAnnualResultBulkIPriPrim.vue?vue&type=script&lang=js&"
export * from "./PrintAnnualResultBulkIPriPrim.vue?vue&type=script&lang=js&"
import style0 from "./PrintAnnualResultBulkIPriPrim.vue?vue&type=style&index=0&id=7613581e&scoped=true&lang=css&"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "7613581e",
  null
  
)

export default component.exports

/* vuetify-loader */
import installComponents from "!../../../../node_modules/vuetify-loader/lib/runtime/installComponents.js"
import { VBtn } from 'vuetify/lib/components/VBtn';
import { VCol } from 'vuetify/lib/components/VGrid';
import { VOverlay } from 'vuetify/lib/components/VOverlay';
import { VProgressCircular } from 'vuetify/lib/components/VProgressCircular';
import { VRow } from 'vuetify/lib/components/VGrid';
import { VSimpleTable } from 'vuetify/lib/components/VDataTable';
import { VSnackbar } from 'vuetify/lib/components/VSnackbar';
installComponents(component, {VBtn,VCol,VOverlay,VProgressCircular,VRow,VSimpleTable,VSnackbar})
